import type { DeepRequired } from '../fixtures.types'

const miOrganisation: DeepRequired<MiOrganisation> = {
  __typename: 'MiOrganisation',
  organisation_id: 'TEST_ID',
  general_email: null,
  name: null,
  primary_phone: null,
  primary_postcode: null,
  primary_posttown: null,
  users: [],
}

export default miOrganisation
